module.exports = __webpack_public_path__ + "img/ico_calendar--bl.7224a6fa.svg";